export default __webpack_public_path__ + "static/media/271.f20ce4a9.jpg";